import React, { PureComponent } from 'react';
import ProductMetaGrid from 'components/product-meta/product-meta-grid';
import getProductPrice from 'util/misc/get-product-price';

import PropTypes from 'prop-types';

export default class ProductMeta extends PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        short_description: PropTypes.array.isRequired,
        price_information: PropTypes.object.isRequired,
        facet: PropTypes.string.isRequired,
    };

    static defaultProps = {
        facet: 'grid',
    };

    render() {
        const { name, price_information, short_description } = this.props;
        const { badge, teaser, original_price } = price_information;
        const realPrice = getProductPrice(price_information);

        return (
            <ProductMetaGrid
                title={name}
                short_description={short_description}
                original_price={original_price}
                hasBadge={!!badge}
                price={realPrice}
                teaser={teaser}
            >
            </ProductMetaGrid>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-meta/index.js